import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent } from './shared/components';
import { AuthGuardService } from './shared/services';
import { ExpensesComponent } from './pages/expenses/expenses.component';
import { InvestmentsComponent } from './pages/investments/investments.component';
// Solo i moduli DevExtreme usati dalle pagine che restano caricate in eager.
// Scheduler, PieChart e DateBox sono ora dichiarati dalle pagine standalone
// caricate in lazy, quindi non entrano piu' nell'initial bundle.
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxFileUploaderModule } from 'devextreme-angular/ui/file-uploader';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxSpeedDialActionModule } from 'devextreme-angular/ui/speed-dial-action';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CheckPdfExtensionPipe } from './shared/pipes/check-pdf-extension.pipe';
import { InvestmentRequestComponent } from './pages/investment-request/investment-request.component';
import { InvestmentRequestsComponent } from './pages/investment-requests/investment-requests.component';

const routes: Routes = [
  {
    path: 'expenses',
    component: ExpensesComponent,
    canActivate: [AuthGuardService],
    data: { animation: 'isRight' }
  },
  {
    path: 'investments',
    component: InvestmentsComponent,
    canActivate: [AuthGuardService],
    data: { animation: 'isLeft' }
  },
  {
    path: 'appointments',
    loadComponent: () => import('./pages/appointments/appointments.component').then(m => m.AppointmentsComponent),
    canActivate: [AuthGuardService],
    data: { animation: 'isRight' }
  },
  {
    path: 'appointment-dashboard',
    loadComponent: () => import('./pages/appointment-dashboard/appointment-dashboard.component').then(m => m.AppointmentDashboardComponent),
    canActivate: [AuthGuardService],
    data: { animation: 'isRight' }
  },
  {
    path: 'appointment-dashboard-detail',
    loadComponent: () => import('./pages/appointment-dashboard-detail/appointment-dashboard-detail.component').then(m => m.AppointmentDashboardDetailComponent),
    canActivate: [AuthGuardService],
    data: { animation: 'isRight' }
  },
  {
    path: 'doctors',
    loadComponent: () => import('./pages/doctors/doctors.component').then(m => m.DoctorsComponent),
    canActivate: [AuthGuardService],
    data: { animation: 'isRight' }
  },
  {
    path: 'investment-request',
    component: InvestmentRequestComponent,
    canActivate: [AuthGuardService],
    data: { animation: 'isRight' }
  },
  {
    path: 'investment-requests',
    component: InvestmentRequestsComponent,
    canActivate: [AuthGuardService],
    data: { animation: 'isRight' }
  },
  {
    path: 'investment-request-doctor',
    loadComponent: () => import('./pages/investment-request-doctor/investment-request-doctor.component').then(m => m.InvestmentRequestDoctorComponent),
    canActivate: [AuthGuardService],
    data: { animation: 'isRight' }
  },
  {
    path: 'login-form',
    component: LoginFormComponent,
    canActivate: [AuthGuardService],
    data: { animation: 'isLeft' }
  },
  {
    path: '**',
    redirectTo: 'investments'
  }
];

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, { useHash: true }),
    DxDataGridModule,
    DxSpeedDialActionModule,
    DxFormModule,
    DxFileUploaderModule,
    DxButtonModule,
  ],
  providers: [AuthGuardService],
  exports: [RouterModule],
  declarations: [
    ExpensesComponent,
    InvestmentsComponent,
    InvestmentRequestComponent,
    InvestmentRequestsComponent,
    CheckPdfExtensionPipe]
})
export class AppRoutingModule { }
